import CircularProgress from '@mui/material/CircularProgress'

function ContentSpinner() {
	return (
		<div className="contentLoader">
			<CircularProgress color="inherit" />
			<span className="loading-loader">Loading...</span>
		</div>
	)
}
export default ContentSpinner
